module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAPCAMAAADEZI+uAAAAAXNSR0IArs4c6QAAAHtQTFRFAAAAqqqqkpK2kra2qqqqmaqqnaenoaGqp6ewoqqypayzo6qxpaqvpKmxo6etoqWupaevo6iuoqevo6awoqewo6iuoaauo6iuoqauo6euoqavoqauoqevoqevoqauo6avoqavoqauoqauoqauoqauoqauoqauo6evoqauJw/hEwAAACh0Uk5TAAYHBwkPGhsdISUnMDtLUl1eY2dxcnWbp667v8nc4+vu8/b7/P3+/giF9+AAAACHSURBVBjTdczbEoIwEAPQoFXxDljRogJVqPn/L/SlMyxt3bdsJge4fthsEZ/S5As4dfw2+7itLccbkJUD+Yx6benMGgDKnqGvNOkeOQBgeekDX9WWo8l9WhSBry2d2Uy5kL6U/V74cznyQ3nmx7L0DwlZ+G1Snvyk7PdVy/f9Xwtku/NxJR8/9OgRFd5atPAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ticket_down.png
// module id = 32TZ
// module chunks = 0